import { CalendarBlank, Clock, MapPin } from '@phosphor-icons/react'
import KioskHeader from '../../components/KioskHeader/KioskHeader'
import useKioskAutoHome from '../../hooks/useKioskAutoHome'
import { useLang } from '../../context/LangContext'

const CONTENT = {
  en: {
    pageTitle: 'Events',
    pageSubtitle: 'Upcoming community activities',

    title: 'Upcoming Events',
    subtitle: 'Stay updated with community programmes and announcements.',

    events: [
      {
        title: 'Community Meet & Greet',
        date: '12 Jun 2026',
        time: '10:00 AM',
        venue: 'Main Hall',
      },
      {
        title: 'Health Awareness Talk',
        date: '18 Jun 2026',
        time: '2:30 PM',
        venue: 'Multipurpose Room',
      },
      {
        title: 'Neighbourhood Clean-up Day',
        date: '25 Jun 2026',
        time: '8:00 AM',
        venue: 'Lobby Entrance',
      },
    ],
  },

  bm: {
    pageTitle: 'Acara',
    pageSubtitle: 'Aktiviti komuniti yang akan datang',

    title: 'Acara Akan Datang',
    subtitle: 'Ikuti program komuniti dan pengumuman terkini.',

    events: [
      {
        title: 'Sesi Ramah Mesra Komuniti',
        date: '12 Jun 2026',
        time: '10:00 PAGI',
        venue: 'Dewan Utama',
      },
      {
        title: 'Ceramah Kesedaran Kesihatan',
        date: '18 Jun 2026',
        time: '2:30 PETANG',
        venue: 'Bilik Serbaguna',
      },
      {
        title: 'Hari Gotong-Royong Kejiranan',
        date: '25 Jun 2026',
        time: '8:00 PAGI',
        venue: 'Pintu Masuk Lobi',
      },
    ],
  },
}

export default function EventsPage() {
  useKioskAutoHome()

  const { lang } = useLang()

  const t = CONTENT[lang] || CONTENT.en

  return (
    <main className="kiosk-page">
      <div className="app-container kiosk-container">
        <KioskHeader
          title={t.pageTitle}
          subtitle={t.pageSubtitle}
        />

        <section className="kiosk-section-card">
          <div className="kiosk-section-card__header">
            <CalendarBlank size={30} />

            <div>
              <h1>{t.title}</h1>
              <p>{t.subtitle}</p>
            </div>
          </div>

          <div className="kiosk-list">
            {t.events.map((event) => (
              <article
                className="kiosk-list-card"
                key={event.title}
              >
                <strong>{event.title}</strong>

                <div>
                  <CalendarBlank size={18} />
                  {event.date}
                </div>

                <div>
                  <Clock size={18} />
                  {event.time}
                </div>

                <div>
                  <MapPin size={18} />
                  {event.venue}
                </div>
              </article>
            ))}
          </div>
        </section>
      </div>
    </main>
  )
}